import React from "react";
 
import { useParams } from "react-router-dom";
import NoticeDetails from "./NoticeDetails";
import { useKeycloak } from "@react-keycloak/web";
import { useFetchNoticeQuery } from "../../../redux/slice/api/FO/noticeApi";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import CpntDetailsNotAccess, { TypeAffichage } from "../../../components/CpntDetailsNotAccess";
import CpntNavigatorNotice from "../components/CpntNavigatorNotice";
 
const PageNoticeDetails: React.FC = () => {
  const { ean:eanUrl , idnotice:idnoticeUrl} = useParams();
  const eanValue = eanUrl ?? "";
  const idnoticeValue = idnoticeUrl ?? "";
  
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  
  const { data: NoticeResult, isFetching: isFetchingNoticeResult } = useFetchNoticeQuery({ EAN: eanValue, IdNotice: idnoticeValue }, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || eanValue === null || eanValue === "",
  });

  const getNavigator = () => {
    return (
    <div className="col-3 mt-2 d-flex justify-content-end">
      <div className="me-2">
      <CpntNavigatorNotice
      currentValueEan={eanValue}//NoticeResult?.NoticeDetails?.Ean}
      currentValueIdNotice={idnoticeValue}//NoticeResult?.NoticeDetails?.Id}
      datas={(() => {
        const storedData = localStorage.getItem("NoticesNavigator");
        try {
          const parsedData = storedData ? JSON.parse(storedData) : [];
          return Array.isArray(parsedData) ? parsedData : [];
        } catch {
          return [];
        }
      })()}
      />
      </div>
    </div>
    )
  }

  return (
    <>
     <div className="container">
    <div className="row">
          <div className="col-9 mt-2 d-flex justify-content-start">
            {<>Votre contact :&nbsp;<b>{NoticeResult?.NoticeDetails?.SuiviPar ? NoticeResult?.NoticeDetails?.SuiviPar : 'biblio@electre.com'}</b></>}
          </div>
          {
            getNavigator()
          }
        </div>
      {NoticeResult && NoticeResult?.Return_IdType_Message === Type_Return_Message.Erreur ?
        <div>
          <CpntDetailsNotAccess text="Aucune notice Electre trouvée." typeAffichage={TypeAffichage.Notice} />
        </div>
      :
    // navigatorPath="../noticedetails/"
     <NoticeDetails NoticeResult={NoticeResult?.NoticeDetails} isFetchingNoticeResult={isFetchingNoticeResult} btnModifierAutoVisible={true} btnModifierMessageVisible={true} ></NoticeDetails>
      }
      </div>
     </>
  );
};
 
export default PageNoticeDetails;
 